import * as React from "react";
import type { GatsbyBrowser } from "gatsby";
import Layout from "./src/components/layout/Layout";
import "./src/styles/_reset.scss";
import "./src/styles/_global.scss";

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

// gatsby-plugin-offline registers a workbox service worker that caches the app
// shell. Without this handler a returning fan keeps the OLD shell until the SW
// happens to update on its own — which is exactly how the newly-deployed perk
// card stayed invisible to anyone who had scanned before (the same stale-SW
// trap the storefront hit). A scan page is worthless offline anyway — it needs
// live perk/nfc state on every visit — so as soon as a new SW is waiting, take
// it and reload so the fan always runs the current build.
export const onServiceWorkerUpdateReady: GatsbyBrowser["onServiceWorkerUpdateReady"] =
  () => {
    window.location.reload();
  };
